import { render, staticRenderFns } from "./NoticeInfo.vue?vue&type=template&id=57c5f66c&scoped=true&"
import script from "./NoticeInfo.vue?vue&type=script&lang=js&"
export * from "./NoticeInfo.vue?vue&type=script&lang=js&"
import style0 from "./NoticeInfo.vue?vue&type=style&index=0&id=57c5f66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c5f66c",
  null
  
)

export default component.exports